import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class PageTitleService {
  constructor(
    private titleService: Title,
    private translateService: TranslateService,
  ) {}

  setTitle(translationKey: string, fallback?: string): void {
    const title = this.translateService.instant(translationKey);
    const finalTitle = title === translationKey && fallback ? fallback : title;

    this.titleService.setTitle(finalTitle);
  }

  setDirectTitle(title: string): void {
    this.titleService.setTitle(title);
  }

  getCurrentTitle(): string {
    return this.titleService.getTitle();
  }
}
